import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
export async function loadMapWithLocationMarker(el, latLng) {
    try {
        setOptions(getGoogleMapsOptions());
        const [{ Map }, { AdvancedMarkerElement }] = await Promise.all([
            importLibrary("maps"), importLibrary("marker")
        ]);
        const map = new Map(el, {
            center: latLng,
            zoom: 15,
            disableDefaultUI: true,
            mapId: `map${Math.random()}`
        });
        new AdvancedMarkerElement({
            position: latLng,
            map: map
        });
    }
    catch (err) {
        console.error('Error when attempting to display map', err.message || err);
    }
}
export async function geocodeAddress(address) {
    var _a;
    try {
        setOptions(getGoogleMapsOptions());
        const { Geocoder } = await importLibrary("geocoding");
        const response = await new Geocoder().geocode({ address });
        if ((_a = response === null || response === void 0 ? void 0 : response.results) === null || _a === void 0 ? void 0 : _a.length) {
            const first = response.results[0];
            return first.geometry.location.toJSON();
        }
    }
    catch (err) {
        console.error('Error when attempting to geocode address', err.message || err);
    }
}
function getGoogleMapsOptions() {
    if (!window.UNTUCKitConfig.googleMapsApiKey) {
        throw new Error('Google Maps API key not set');
    }
    return {
        key: window.UNTUCKitConfig.googleMapsApiKey,
        v: "weekly"
    };
}
